import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { CustomRegistrationService } from '../custom-registration.service';

@Component({
    selector: 'app-account-registration',
    templateUrl: './account-registration.component.html',
    styleUrls: ['./account-registration.component.scss'],
    standalone: false
})
export class AccountRegistrationComponent implements OnInit, OnDestroy {
  header: string;
  formData: any;
  twoFormsData: any[];
  creditInvoice: string;
  compName = 'AccountRegistrationConfirmationBannerComponent';
  subscription: Subscription;
  accSub: Subscription;
  constructor(
    private readonly accountRegService: CustomRegistrationService,
    private readonly formBuilder: FormBuilder,
    private readonly cdr: ChangeDetectorRef,
    private readonly user: UserAccountFacade,
    private readonly router: Router
  ) {
    if (this.router.navigated) {
      localStorage.removeItem('finalBillingDetails');
      localStorage.removeItem('replicateForm');
      localStorage.removeItem('formTempValue');
      localStorage.removeItem('billingFormDetails');
      localStorage.removeItem('contactDetails');
    }
  }

  ngOnInit(): void {
    this.header = 'billingDetails';
    this.creditInvoice = 'invoiceTable';
    this.accSub = this.accountRegService.sectionChange.subscribe(
      (sectionDetails) => {
        this.header = sectionDetails.header;
        if (!!sectionDetails?.form) {
          this.formData = sectionDetails.form;
        }
        if (!!sectionDetails?.forms) {
          this.twoFormsData = sectionDetails.forms;
        }
        if (sectionDetails.header === 'contacts') {
          this.formData = sectionDetails?.totalFormData;
        }
        this.cdr.detectChanges();
      }
    );
  }

  ngOnDestroy(): void {
    this.accSub?.unsubscribe();
  }

  onheaderPassing(dt: any) {
    this.twoFormsData = dt.totalFormData;
    this.header = dt.header;
  }
}
